export default class FriendlyError extends Error {
	// This is a custom error class that can be used to display friendly error messages to the user.
	// It extends the built-in Error class and adds a `friendlyMessage` property.
	// The `friendlyMessage` property is intended to be used for displaying user-friendly error messages.
	constructor(message: string) {
		super(message);
		this.name = "FriendlyError";
	}
}
